import { Link } from "react-router-dom";
import { HeartHandshake, PackageCheck, Sparkles, Truck } from "lucide-react";

const VALUES = [
  { icon: HeartHandshake, title: "Made personal", text: "Every mug, frame and cushion is printed with your photos and words — no two gifts are ever the same." },
  { icon: PackageCheck, title: "Quality checked", text: "Each piece goes through a print and finish check before it's wrapped, so what arrives is exactly what you imagined." },
  { icon: Truck, title: "Delivered across India", text: "Standard, express and same-day delivery options with honest timelines shown before you pay." },
  { icon: Sparkles, title: "Crafted to delight", text: "From the packaging to the handwritten note card, the unboxing is part of the gift." },
];

export default function AboutPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-12 lg:py-16" data-testid="about-page">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#B45309]">About Us</p>
      <h1 className="font-serif text-3xl sm:text-4xl font-bold text-stone-900 mt-3 tracking-tight">We turn your memories into gifts</h1>
      <p className="text-stone-500 mt-4 leading-relaxed max-w-2xl">
        Customize Gift Online is a personalized gifting studio. We believe the best gifts aren't the most expensive ones —
        they're the ones with a face, a name, a date, an inside joke. That's why everything we make — mugs, photo frames,
        cushions, keepsakes and corporate gifts — is customized with your photos and messages, printed with care and
        delivered anywhere in India.
      </p>
      <p className="text-stone-500 mt-4 leading-relaxed max-w-2xl">
        From a single birthday mug to five hundred branded corporate hampers, every order gets the same attention:
        honest pricing, real delivery estimates and support from actual humans.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-12">
        {VALUES.map((v) => (
          <div key={v.title} className="p-6 rounded-2xl bg-white border border-[#E9E2D7] card-lift">
            <v.icon size={22} className="text-[#B45309]" />
            <h3 className="font-serif text-lg font-bold text-stone-900 mt-3">{v.title}</h3>
            <p className="text-sm text-stone-500 mt-2 leading-relaxed">{v.text}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 p-6 rounded-2xl bg-[#1C1917] text-[#FDFBF7] flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex-1">
          <p className="font-serif text-lg font-bold">Have a question or a big order in mind?</p>
          <p className="text-sm text-stone-400 mt-1">customizegiftonline@gmail.com · 9899534126</p>
        </div>
        <Link to="/contact" className="shrink-0 px-6 h-11 rounded-full bg-[#B45309] text-white text-sm font-bold grid place-items-center hover:bg-[#92400E] transition-colors" data-testid="about-contact-cta">Contact Us</Link>
      </div>
    </div>
  );
}
